/** @jsx jsx */
import React, { ReactNode } from 'react';
import { css, jsx } from '@emotion/core';
import { textFontSize } from 'components/styles';

const styles = {
  wrapper: css({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    fontSize: textFontSize.re,
  }),
  input: css({
    marginTop: '4px',
  }),
  error: css({
    marginTop: '4px',
    color: 'red',
  }),
};

/**
 * フォームのレイアウト
 *  - display: flexでレイアウト
 *  - ラベルとinputの間にマージンをとる
 */
const VerticalLabelFormLayout: React.FC<{
  label: ReactNode;
  input: ReactNode;
  errorMsg?: string;
}> = ({
  label, input, errorMsg,
}) => (
  <div css={css(styles.wrapper)}>
    {label}
    <div css={styles.input}>
      {input}
    </div>
    <span css={styles.error}>
      {errorMsg}
    </span>
  </div>
);

export default VerticalLabelFormLayout;
